export const colors = {
  primary: {
    50: '#FFF0F3',
    100: '#FFE4E8',
    200: '#FFCCD5',
    300: '#FFA3B3',
    400: '#FF758F',
    500: '#FF4D6D', // Brand Primary
    600: '#E03152',
    700: '#C21B3D',
    800: '#9E102E',
    900: '#800B23',
  },
  secondary: {
    50: '#F3F0FF',
    100: '#E5DBFF',
    200: '#D0BFFF',
    300: '#B197FC',
    400: '#9470FF',
    500: '#6C63FF', // Brand Secondary
    600: '#5849E0',
    700: '#4635C2',
    800: '#3524A3',
    900: '#261685',
  },
  success: {
    500: '#00C853',
    light: '#E8F8EF',
    dark: '#00A344',
  },
  warning: {
    500: '#FFC107',
    light: '#FFF8E1',
    dark: '#FFA000',
  },
  danger: {
    500: '#EF4444',
    light: '#FEE2E2',
    dark: '#DC2626',
  },
  background: {
    light: '#F8FAFC',
    dark: '#0B0F17',
    cardLight: '#FFFFFF',
    cardDark: '#161F30',
    glassLight: 'rgba(255, 255, 255, 0.85)',
    glassDark: 'rgba(22, 31, 48, 0.85)',
  },
  border: {
    light: '#E2E8F0',
    dark: '#2D3748',
  },
  text: {
    primaryLight: '#0F172A',
    secondaryLight: '#64748B',
    primaryDark: '#F8FAFC',
    secondaryDark: '#94A3B8',
  }
};
